import Devise from "@kaspernj/api-maker/build/devise"
import env from "shared/env"

const peakflowJsAuthToken = globalThis.PEAKFLOW_JS_AUTH_TOKEN || env["PEAKFLOW_JS_AUTH_TOKEN"]

// `Peakflow` is a global provided by the external https://www.peakflow.io/packs/js/api.js
// script. When Peakflow is down that script fails to load, leaving the global
// undefined. Guard on it so a missing reporter degrades to a console error
// instead of throwing at pack init time and taking the whole app down with it.
const Peakflow = globalThis.Peakflow

if (peakflowJsAuthToken && Peakflow) {
  globalThis.peakFlowErrors = new Peakflow.BugReporting({authToken: peakflowJsAuthToken})
  globalThis.peakflowErrors = globalThis.peakFlowErrors
  globalThis.peakFlowErrors.collectEnvironment(() => {
    return {
      currentUserId: Devise.currentUser()?.id(),
      currentUserEmail: Devise.currentUser()?.email()
    }
  })
} else if (peakflowJsAuthToken) {
  console.error("Peakflow error reporting is unavailable: the Peakflow API script failed to load")
}
